import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import { ExamSession, IExamSession } from '@/shared/model/exam-session.model';
import { latLng } from 'leaflet';
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LIcon } from 'vue2-leaflet';
import L from 'leaflet';
import { ExamCenter } from '@/shared/model/exam-center.model';

//Needed for IE Support: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/dispatchEvent#Browser_Compatibility
//https://stackoverflow.com/a/49071358/79677
const SendBrowserAgnosticEvent = <T extends HTMLElement | Window>(elem: T, eventName: string): Event => {
  let event;
  if (typeof Event === 'function') {
    event = new Event(eventName);
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
  }
  elem.dispatchEvent(event);
  return event;
};

@Component({
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LIcon,
  },
})
export default class MapSessions extends Vue {
  @Prop()
  public examSessions: IExamSession[];
  @Prop()
  public selectedLatitude: number;
  @Prop()
  public selectedLongitude: number;
  @Prop()
  public selectedSession: ExamSession;
  @Prop()
  public selectedCenter: ExamCenter;

  public zoom: number = 7;
  public center: number = latLng(this.selectedLatitude, this.selectedLongitude);
  public url: String = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  public attribution: String = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  public mapOptions = {
    zoomSnap: 0.5,
  };
  public defaultIcon = L.icon({
    iconUrl: '/content/images/map_marker-darkerblue.png',
    iconSize: [36, 55],
    iconAnchor: [19, 54],
  });
  public selectedIcon = L.icon({
    iconUrl: '/content/images/map_marker-pink.png',
    iconSize: [36, 55],
    iconAnchor: [19, 54],
  });

  @Watch('examSessions')
  examSessionsChanged() {
    // fix for rendering the map (https://stackoverflow.com/a/46713117/12446520)
    // https://stackoverflow.com/a/56119057/12446520
    SendBrowserAgnosticEvent(window, 'resize');
  }

  /**
   * Return latitude and longitude for map markers
   * @param examSession examSession to display on map
   */
  public getLatLng(examSession: ExamSession) {
    return latLng(examSession.examCenter.latitude, examSession.examCenter.longitude);
  }

  /**
   * Return icon to display. SelectedIcon if session is selected by user, DefaultIcon otherwise
   * @param session examSession to display on map
   */
  public getIcon(examSession: ExamSession) {
    if (
      (this.selectedCenter !== null && examSession.examCenter.id === this.selectedCenter.id) ||
      (this.selectedSession !== null && examSession.id === this.selectedSession.id)
    ) {
      return this.selectedIcon;
    } else {
      return this.defaultIcon;
    }
  }

  /**
   * Return z-index of selected markers.
   * Allow the selected marker to be on foreground and visible when multiple markers on same location (multiple sessions in same exam center)
   * @param examSession
   * @return z-index value
   */
  public getZIndex(examSession: ExamSession) {
    if (examSession === this.selectedSession) {
      return 10;
    }
  }

  /**
   * Emit the selected examCenter to parent component
   * @param examSession examSession clicked on map
   */
  public emitExamCenterInfos(examCenter: ExamCenter) {
    this.$emit('clickOnMapMarker', examCenter);
  }

  /**
   * Update center of the map when new markers are displayed
   */
  public onAddMarkers() {
    this.center = latLng(this.selectedLatitude, this.selectedLongitude);
  }
}
